module.exports = __webpack_public_path__ + "img/logo Telemed.f893052e.svg";